module.exports = __webpack_public_path__ + "img/solution_building4.d66c0052.png";